import { render, staticRenderFns } from "./ToPayOrder.vue?vue&type=template&id=22a82c15&scoped=true"
import script from "./ToPayOrder.vue?vue&type=script&lang=js"
export * from "./ToPayOrder.vue?vue&type=script&lang=js"
import style0 from "./ToPayOrder.vue?vue&type=style&index=0&id=22a82c15&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a82c15",
  null
  
)

export default component.exports